import React from "react";
import formatDate from "date-fns/format";
import styled from "styled-components";
import { globalTheme } from "@clds/component-theme";
import t from "common/i18n";
import { DATE_FORMAT } from "../../data/consts";
import service from "../../service";

const SectionBox = styled.section`
	padding: ${globalTheme.spacing.md};
	padding-bottom: ${globalTheme.spacing.xxl};
	> label {
		font-weight: bold;
		white-space: nowrap;
		display: block;
		padding-bottom: ${globalTheme.spacing.xs};
		font-size: ${globalTheme.font.size.xs};
	}
`;

const SectionLine = styled.div`
	display: flex;
	padding-bottom: ${globalTheme.spacing.sm};
	label {
		display: block;
		width: 100px;
	}
	span {
		color: ${globalTheme.palette.secondary};
		width: 210px;
	}
	a {
		text-decoration: underline;
	}
`;
const LICENSE_URL = service().getLicenseUrl();

export default ({ selectedAsset }) => (<SectionBox>
		<SectionLine>
			<label>{t("unsplash.summary.credit")}</label>
			<a target="_blank" rel="noopener noreferrer" href={selectedAsset.user.links.html} data-test="summary-page-credit">
				{selectedAsset.user.name}
			</a>
		</SectionLine>
		{selectedAsset.location?.title && <SectionLine>
			<label>{t("unsplash.summary.location")}</label>
			<span data-test="summary-page-location">{selectedAsset.location?.title}</span>
		</SectionLine>}
		<SectionLine>
			<label>{t("unsplash.summary.published_at")}</label>
			<span data-test="summary-page-published-at">{formatDate(new Date(selectedAsset.created_at), DATE_FORMAT)}</span>
		</SectionLine>
		<SectionLine>
			<label>{t("unsplash.summary.permission")}</label>
		<a target="_blank" rel="noopener noreferrer" href={LICENSE_URL} data-test="summary-page-permission">
				{t("unsplash.summary.free_to_use")}
			</a>
		</SectionLine>
		<SectionLine>
			<label>{t("unsplash.summary.description")}</label>
			<span data-test="summary-page-description">{selectedAsset.title}</span>
		</SectionLine>
	</SectionBox>
);
